import { Injectable } from '@angular/core';

import { UserService } from './user.service';


@Injectable()
export class AppService {
  initialAppLoaded = false;

  constructor(
    public user: UserService
  ) { }

  initApp(): void {
    // TODO: Acá deberían consultarse con token los privilegios de la persona

    this.user.verifiedToken();

    this.user.initialize();

    //this.user.verifiedAuthenticated();



    this.initialAppLoaded = true;
  }




}
